import {Heading, Link} from '@primer/react'

import {Search} from '../Search/Search'

import styles from './Header.module.css'

type Props = {
  searchQuery: string
  onSearchChange: (query: string) => void
}

export function Header({searchQuery, onSearchChange}: Props) {
  return (
    <header className={styles.header}>
      <div className={styles.content}>
        <Heading as="h1" className={styles.heading}>
          Discover AI resources
        </Heading>

        <p className={styles.subheading}>Search across AI resources surfaced by Agent Finder.</p>

        <p className={styles.note}>
          Agent Finder implements the{' '}
          <Link href="https://agenticresourcediscovery.org" inline>
            Agentic Resource Discovery (ARD) specification
          </Link>
          .
        </p>
      </div>

      <Search searchQuery={searchQuery} onSearchChange={onSearchChange} />
    </header>
  )
}
